<template>
  <div class="page_box">
    <div class="page_table_box" style="height:100%">
      <div class="select-title-box">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          :style="
            btnIndex == index
              ? 'box-shadow: 0px 0px 16px 0px #e5f4ff;'
              : 'border: 1px solid #f5f5f7;'
          "
          class="btn-type-box"
          @click="titleClick(index)"
        >
          <img :src="item.icon" alt="" />
          <div
            style="text-align:center;font-size:16px;color:#525863;font-weight: 500;"
          >
            {{ item.title }}
          </div>
          <span
            style="text-align:center;font-size:12px;color:#9CA1A7;margin-top:4px"
          >
            {{ item.contentTop }}<br />{{ item.contentbot }}
          </span>
        </div>
      </div>
      <div v-if="btnIndex == 0" class="detail-box">
        <div class="page_option_box">
          <div class="title-box">
            <div></div>
            <span>
              问题帮助
            </span>
          </div>
          <div class="search_box">
            <el-input
              class="search-input"
              v-model="issueObj.richTextContent"
              placeholder="请输入问题内容关键词......"
              size="small"
              clearable
            >
            </el-input>
            <el-button type="primary" plain size="mini" @click="getIssueList"
              >搜索</el-button
            >
          </div>
        </div>
        <div class="page_table_box">
          <div class="school_table_box centel">
            <div
              v-for="(item, index) in issueList"
              :key="index"
              v-show="issueList.length > 0"
            >
              <div class="title-box-two">
                <div v-if="item.new == 1" class="icon-box"></div>
                <div
                  class="title"
                  :style="
                    item.new == 1 ? 'margin-left:11px' : 'margin-left:28px'
                  "
                >
                  {{ item.header }}
                </div>
              </div>
              <div class="d-content-box">
                <span v-html="item.richTextContent"></span>
              </div>
              <hr />
            </div>
            <div v-show="issueList.length == 0">暂无数据</div>
          </div>
          <div class="pagination_box">
            <el-pagination
              :page-size="issueObj.pageSize"
              :pager-count="5"
              :current-page="issueObj.pageNum"
              :total="issueTotal"
              @current-change="issueCurrentChange"
              layout="total, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="detail-box" v-if="btnIndex == 1">
        <div class="page_option_box">
          <div class="title-box">
            <div></div>
            <span>
              建议反馈
            </span>
          </div>
        </div>
        <div class="page_table_box">
          <div class="school_table_box centel" style="height:100%">
            <div class="content-box" v-show="suggestShow">
              <el-input
                class="input"
                v-model="suggestObj.header"
                placeholder="请输入标题"
                size="small"
                clearable
              ></el-input>
              <el-input
                class="input"
                v-model="suggestObj.richTextContent"
                placeholder="请描述您回馈的建议…"
                size="small"
                type="textarea"
                :rows="10"
                show-word-limit
                maxlength="300"
              ></el-input>
              <div class="confirm-button">
                <el-button
                  type="primary"
                  round
                  v-loading="saveLoading"
                  @click="suggestSaveClick"
                  size="medium"
                  >提&nbsp;&nbsp;&nbsp;交</el-button
                >
              </div>
            </div>

            <div class="content-box" v-show="!suggestShow">
              <div>
                <img
                  class="confirm-img"
                  src="@/assets/img/adviceIcon/confirm-icon.gif"
                  alt="反馈成功"
                />
                <span class="confirm-message">
                  您的建议小安已接收<br />感谢您反馈
                </span>
              </div>
              <div class="confirm-button">
                <el-button
                  type="primary"
                  round
                  @click="suggestConfirmClick"
                  size="medium"
                  >继续反馈</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AdviceFeedback",
  data() {
    return {
      titleList: [
        {
          icon: require("@/assets/img/adviceIcon/advice-icon2.png"),
          title: "问题帮助",
          contentTop: "有问题找小安",
          contentbot: "小安助你解疑惑"
        },
        {
          icon: require("@/assets/img/adviceIcon/advice-icon3.png"),
          title: "建议反馈",
          contentTop: "您的建议反馈",
          contentbot: "是小安成长的助力"
        }
      ],
      btnIndex: 0,
      suggestObj: {
        contactNumber: this.$store.getters.getUserInfo.userPhone, //用户手机号
        feedbackPersonId: this.$store.getters.getUserInfo.userId, //当前登陆人id
        feedbackSchool: this.$store.getters.getUserInfo.schoolId, //当前登录账号所属学校id
        header: "", //建议反馈标题
        richTextContent: "" //将反馈内容
      },
      saveLoading: false,
      suggestShow: true,
      issueObj: {
        pageNum: 1,
        pageSize: 10,
        type: 2,
        feedbackPersonId: this.$store.getters.getUserInfo.userId,
        richTextContent: ""
      },
      issueTotal: 0,
      issueList: []
    };
  },
  methods: {
    titleClick(index) {
      if (this.btnIndex == index) {
        return;
      }
      //
      if (index == 0) {
        this.getIssueList();
      }
      if (index == 1) {
        this.suggestShow = true;
      }
      this.btnIndex = index;
    },
    async getIssueList() {
      let res = await this.$Http.getNewsAnnouncementList(this.issueObj);
      if (res.code == 200) {
        this.issueList = res.data.list || [];
        this.issueTotal = res.data.total || 0;
      } else if (res.code == 101) {
        this.issueList = [];
      } else {
        this.$message({
          message: res.message || "列表获取失败",
          type: "error"
        });
        this.issueList = [];
      }
    },
    issueCurrentChange(val) {
      this.issueObj.pageNum = val;
      this.getIssueList();
    },
    // 建议反馈提交
    suggestSaveClick() {
      if (
        this.suggestObj.header == "" ||
        this.suggestObj.richTextContent == ""
      ) {
        this.$message({
          message: "请填写完整建议反馈信息！",
          type: "warning"
        });
      } else {
        this.saveLoading = true;
        this.saveInfo();
      }
    },
    async saveInfo() {
      let res = await this.$Http.submitFeedback(this.suggestObj);
      this.saveLoading = false;
      if (res.code == 200) {
        this.$message({
          message: "建议反馈提交成功",
          type: "success"
        });
        // 切换提交成功界面
        this.suggestShow = false;
        this.suggestObj.header = "";
        this.suggestObj.richTextContent = "";
      } else {
        this.$message({
          message: "请填写完整建议反馈信息！",
          type: "error"
        });
      }
    },
    // 提交成功继续反馈按钮
    suggestConfirmClick() {
      this.suggestShow = true;
    }
  },
  created() {},
  mounted() {
    this.getIssueList();
  }
};
</script>

<style scoped lang="scss">
.btn-type-box {
  width: 138px;
  height: 138px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;

  transition: transform 0.3s;
  &:hover {
    transform: scale(1.05);
  }
  &:nth-child(1) {
    img {
      width: 44px;
      height: 44px;
      margin-top: 15px;
    }
    div {
      margin-top: 2px;
    }
  }
  &:nth-child(2) {
    img {
      width: 44px;
      height: 44px;
      margin-top: 8px;
    }
    div {
      margin-top: 9px;
    }
  }
  &:nth-child(3) {
    img {
      width: 44px;
      height: 44px;
      margin-top: 15px;
    }
    div {
      margin-top: 2px;
    }
  }
}
.title-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  line-height: 25px;
  div {
    width: 4px;
    height: 12px;
    background: #0091ff;
    border-radius: 2px;
  }
  span {
    margin-left: 12px;
    width: 76px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303030;
  }
}
.content-box {
  width: 90%;
  height: 90%;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px #f7f5f5;
  border-radius: 8px;
  .input {
    &:nth-child(1) {
      margin: 24px 24px 0px 24px;
      width: calc(100% - 48px);
      height: 40px;
    }
    &:nth-child(2) {
      margin: 6px 24px 0px 24px;
      width: calc(100% - 48px);
      max-height: calc(100% - 130px);
    }
  }
}
.content-box-two {
  max-height: 400px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px #f7f5f5;
  border-radius: 8px;
  margin-top: 29px;
  margin-left: 26px;
  margin-right: 26px;
  overflow-y: scroll;
  .title-box-two {
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon-box {
      width: 7px;
      height: 7px;
      background: #c25858;
      border-radius: 3.5px;
      margin-left: 10px;
    }
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303030;
      word-wrap: break-word;
    }
  }
  .d-content-box {
    margin-top: 8px;
    margin-left: 28px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #919191;
    word-wrap: break-word;
    line-height: 22px;
  }
  hr {
    margin: 8px 0px;
  }
}
.pagination {
  display: flex;
  // align-items: center; //上下居中
  justify-content: center; //左右居中
}
.confirm-img {
  margin-top: 30px;
  height: 40px;
  width: 40px;
  margin-left: calc((100% - 40px) / 2);
}
.confirm-message {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #303030;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 2px;
}
.confirm-button {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
  .search-input {
    width: 80%;
  }
  /deep/ .el-button {
    margin-left: 10px;
    background: -webkit-gradient(
      linear,
      100% 0%,
      0% 0%,
      from(#b5d0ff),
      to(#66a7ff)
    );
    color: #fff;
  }
}
.select-title-box {
  height: 160px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail-box {
  height: calc(100% - 160px);
}
.centel {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
}
</style>
